import { compareStrings } from '../../../../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/sorters';
import { ColumnKeys } from '../grid-config';
import { ExchangeAntimalwareScanTaskTargetExclusion } from '@nirvana/shared/dtos/types/policies/common';
import { getExchangeAntimalwareScanTaskExclusionType } from '../../../../../../../../utils/uiSettings/exchange/exchange-protection.values';

// sort by column type
export function sortByColumn(
  item1: ExchangeAntimalwareScanTaskTargetExclusion,
  item2: ExchangeAntimalwareScanTaskTargetExclusion,
  columnName: string,
  direction: string
): number {
  switch (columnName) {
    case ColumnKeys.TYPE:
      return compareStrings(
        getExchangeAntimalwareScanTaskExclusionType(item1.type),
        getExchangeAntimalwareScanTaskExclusionType(item2.type),
        direction
      );

    case ColumnKeys.SCOPE:
      return compareStrings(item1.scope, item2.scope, direction);
  }

  return 0;
}
